<template>
  <div style="height:100vh;width:100%;" v-loading="isLoading">
    <div style="height:100vh;width:100%;" v-if="readerType == 'xiaozhitoushi' && xiaozhitoushiLonginged">
      <!-- 小智透视 -->
      <cmdp-workshop-perspective
                              orgFullName="中广核核技术发展股份有限公司"
                              orgSecCode="003816"
                              :templateName="templateName"
                              :domain="serverUrl"
                              :satoken="requestHeader.satoken"
                              :raw.prop="raw"
                              hideNotice
                              hideMessageBtn
      >
        <div slot="bar-btn" style="width:34px;">
          <el-button type="text" icon="el-icon-message" @click="openUserMesssage" title="我的消息"></el-button>
        </div>
        <el-dropdown slot="bar-close" style="font-size:20px;" @command="handelMenulSelect">
            <span class="el-dropdown-link">
              <i class="el-icon-user-solid"></i>
            </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="showInfo">修改信息</el-dropdown-item>
            <el-dropdown-item command="logout">退出账号</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </cmdp-workshop-perspective>
    </div>
    <el-dialog top="10vh" title="修改信息" :visible.sync="showInfoDialog" width="60%" :close-on-click-modal='false' :fullscreen="false" @close="btnCloseInfoDialog" >
      <user-info @saveSuccess="btnCloseInfoDialog" @saveCancel="btnCloseInfoDialog"></user-info>
    </el-dialog>

    <selectTemplateDialog ref="selectTemplateDialog" @close="close"></selectTemplateDialog>
  </div>
</template>

<script>
import userInfo from "../../user/info"
import selectTemplateDialog from "@/components/common/selectTemplateDialog";
export default {
  name: 'smartPerspective',
  components: { userInfo, selectTemplateDialog },
  data() {
    return {
      templateName:'',
      readerType: '',
      requestHeader: {
        satoken: localStorage.getItem('USER_TOKEN_VAL')
      },
      serverUrl: config.serverUrl,
      raw: {},
      isLoading: false,
      showInfoDialog : false,

      xiaozhitoushiLonginged: false
    }
  },

  methods: {
    close(){
      if (confirm("您确定要关闭吗？")){
          window.opener=null;
          window.open('','_self');
          window.close();
      }
    },

    openUserMesssage() {
      this.$EventBus.$emit('opendialogTaskCenter')
    },

    handelMenulSelect( command ){
      if( command == 'logout' )
        this.logout();
      else
        this.showInfo();
    },
    showInfo(){
      this.showInfoDialog = true;
    },
    btnCloseInfoDialog(){
      this.showInfoDialog = false;
    },

    logout(){
      localStorage.removeItem( 'USER_ISLOGIN' );
      localStorage.removeItem( 'USER_TOKEN_TAG' );
      localStorage.removeItem( 'USER_TOKEN_VAL' );

      sessionStorage.clear();
      location.reload();
    }
  },

  created() {
    if (localStorage.getItem("USER_ISLOGIN") != 'true') {
      this.$message({
        type: 'warning',
        message: '未找到您的登录信息'
      })
      this.$router.push({name: 'index'})
      return;
    }
    sessionStorage.setItem("USER_TOKEN_VAL", localStorage.getItem('USER_TOKEN_VAL'));

    this.readerType = this.$route.meta.type;

    //接收选择模板弹窗数据
    this.$EventBus.$on("selectTemplate", (e) => {
      this.templateName = e.templateName;
      this.raw = e.raw;
      this.xiaozhitoushiLonginged = true;
    });

  },

  mounted() {
    this.$refs.selectTemplateDialog.showDialog();
  }
}
</script>

<style scoped lang="less">
.mydialog /deep/.el-dialog__header{
  margin-bottom:30px;
}
.el-button {
  color: rgba(0, 0, 0, 0.9);
  font-size: 14px;

  /deep/ i {
    color: rgba(0, 0, 0, 0.7);
    font-size: 24px;
  }
}
// .el-button--primary.is-plain {
//   background: #ecf5ff;
// }
.title-center {
  margin-top:10px;
  //margin-bottom:5px;
  text-align: center;
  font-size: 18px;
}
.select-model-content {
  margin-top:5px;
  height: 28px;
}
.select-template {
  display: inline-block;
  font-weight: bold;
  background:rgb(64, 158, 255) ;
  padding: 3px 10px;
  color:#ffffff;
}
.search-area {
  margin-top: 5px;
}
.footer-center {
  text-align: center;
}
</style>
